import { gql } from 'graphql-request';

export const GET_VANADIUM_LOCATION = gql`
  query getVanadiumLocation($fleetId: Int) {
    vanadiumLocation(fleetId: $fleetId) {
      companyName
      locationName
      batteryCount
      userCount
      batteries {
        vanadiumBESSSerial
        deviceType
        lastDataUpdateTimestamp
        operational
        state
        alarm1 {
          code
          moduleIds
        }
        alarm2 {
          code
          moduleIds
        }
        leaks
        modules {
          vanadiumBESSSerial
          deviceType
          lastDataUpdateTimestamp
          operational
          state
          alarm1
          alarm2
          leaks
        }
      }
    }
  }
`;
